import { render, staticRenderFns } from "./BusinessOmniplayEventsPresta.vue?vue&type=template&id=4d587782"
import script from "./BusinessOmniplayEventsPresta.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsPresta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports